import { createMuiTheme } from '@material-ui/core';
var createDesignSystemTheme = function (themeOptions) {
    return createMuiTheme(themeOptions);
};
export default createDesignSystemTheme;
